import type { RaidResult } from "@engine";
import type { Session } from "../state.ts";
import { $, hide, show } from "./dom.ts";

const DONE_KEY = "life-village-morning-done";

export type Morning =
  | { kind: "none" }
  | { kind: "collect" }
  | { kind: "raid"; raid: RaidResult };

/** `?demo=collect` or `?demo=raid` replays a morning for previews and testing. */
function demo(): string | null {
  return new URLSearchParams(window.location.search).get("demo");
}

function doneKey(session: Session): string {
  const state = session.result.state;
  return `${state.date}:${state.collect?.happened ? "collect" : ""}${state.raid?.happened ? "raid" : ""}`;
}

function alreadyDone(session: Session): boolean {
  try {
    return localStorage.getItem(DONE_KEY) === doneKey(session);
  } catch {
    return false;
  }
}

export function markMorningDone(session: Session): void {
  try {
    localStorage.setItem(DONE_KEY, doneKey(session));
  } catch {
    // Storage blocked: the morning card simply shows again next visit.
  }
}

export function morningState(session: Session): Morning {
  const mode = demo();
  if (mode === "raid") {
    return { kind: "raid", raid: { happened: true, goldStolen: 1_200, crystalsStolen: 150, wallDamage: 80 } };
  }
  if (mode === "collect") {
    return { kind: "collect" };
  }
  if (alreadyDone(session)) {
    return { kind: "none" };
  }
  const { collect, raid } = session.result.state;
  if (collect?.happened) {
    return { kind: "collect" };
  }
  if (raid?.happened) {
    return { kind: "raid", raid };
  }
  return { kind: "none" };
}

export function showCollectBanner(): void {
  show($("morning-modal"));
}

function lossChip(amount: string, label: string): HTMLDivElement {
  const chip = document.createElement("div");
  chip.className = "loss";
  const value = document.createElement("strong");
  value.textContent = amount;
  const caption = document.createElement("span");
  caption.textContent = label;
  chip.append(value, caption);
  return chip;
}

export function showRaid(raid: RaidResult): void {
  $("raid-losses").replaceChildren(
    lossChip(`−${raid.goldStolen.toLocaleString("en-GB")}`, "gold"),
    lossChip(`−${raid.crystalsStolen.toLocaleString("en-GB")}`, "crystals"),
    lossChip(`−${raid.wallDamage} HP`, "walls"),
  );
  show($("raid-card"));
  show($("raid-actions"));
}

export function endRaid(): void {
  hide($("raid-card"));
  hide($("raid-actions"));
}
